import * as types from '../../../../types/masters/stoneAttribute/stoneQuality/stoneQualityTypes';
import * as api from '../../../../../api/masters/stoneAttribute/stoneQuality/stoneQualityApi';

export const fetchStoneQualities = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STONE_QUALITY_REQUEST });
  try {
    const data = await api.fetchStoneQualities();
    dispatch({ type: types.FETCH_STONE_QUALITY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_STONE_QUALITY_FAILURE, payload: error.message });
  }
};

export const addStoneQuality = (stoneQuality) => async (dispatch) => {
  try {
    const res = await api.addStoneQuality(stoneQuality);
    dispatch({ type: types.ADD_STONE_QUALITY_SUCCESS, payload: res });
    dispatch(fetchStoneQualities());
  } catch (error) {
    dispatch({ type: types.STONE_QUALITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateStoneQuality = (id, stoneQuality) => async (dispatch) => {
  try {
    console.log('Updating stone quality with ID:', id, 'Data:', stoneQuality);
    const res = await api.updateStoneQuality(id, stoneQuality);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_STONE_QUALITY_SUCCESS, payload: res });
    dispatch(fetchStoneQualities());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.STONE_QUALITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteStoneQuality = (id) => async (dispatch) => {
  try {
    await api.deleteStoneQuality(id);
    dispatch({ type: types.DELETE_STONE_QUALITY_SUCCESS, payload: id });
    dispatch(fetchStoneQualities());
  } catch (error) {
    dispatch({ type: types.STONE_QUALITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setStoneQualityEdit = (stoneQuality) => ({
  type: types.SET_STONE_QUALITY_EDIT,
  payload: stoneQuality,
});

export const clearStoneQualityEdit = () => ({
  type: types.CLEAR_STONE_QUALITY_EDIT,
}); 